import React from "react";
import { Card } from "primereact/card";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ProgressSpinner } from "primereact/progressspinner";
const DashboardResolutionTimeCard = () => {
  const { t } = useTranslation(["common", "dashboard"]);
  const { averageResolutionTime } = useSelector(
    (state: any) => state.dashboard.dashboardCardsData
  );
  const isDashboardCardsDataLoaded = useSelector(
    (state: any) => state.dashboard.isDashboardCardsDataLoaded
  );
  return (
    <Card className="card card-1-2">
      <div className="card-content">
        <div className="d-flex gap-2 justify-content-start align-items-center">
          <div className="circle inactive p-4 d-flex justify-content-center align-items-center">
            <ScheduleOutlinedIcon />{" "}
          </div>
          <h6 className="card-title">{t("avgResolutionTime")}</h6>
        </div>
        {isDashboardCardsDataLoaded && (
          <div className="card-data d-flex gap-2 justify-content-start align-items-end mt-4">
            <h1 className="weight-600">{averageResolutionTime}</h1>
            <span className="weight-600">{t("hours")}</span>
          </div>
        )}
        {!isDashboardCardsDataLoaded && <ProgressSpinner />}
      </div>
    </Card>
  );
};

export default DashboardResolutionTimeCard;
